import "./RightDash.scss";
import requests from "../../assets/images/requests.jpg";

const RightDash = () => {
  return (
    <div className="right-dash">
      <h2 className="right-dash__title">Request Forms</h2>
      <img src={requests} alt={"baking"} className="right-dash__image" />
    </div>
  );
};

export default RightDash;
